import React from "react";
import { Helmet } from "react-helmet-async";
import "./aboutCareer.css";
import "./aboutStory.css";
import "../../../styles/general.css";
import "../../../styles/queries.css";
import { openPositions } from "./AboutCareerPositions";
import AboutCareerList from "./AboutCareerList/AboutCareerList";

const AboutCareer = () => {
  const openPositionsLabor = openPositions.filter(
    (position) => position.typeOfPosition === "labor"
  );

  // Create structured data for job postings
  const jobPostingsStructuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Bálint Analitika Laboratórium",
    url: "https://balintanalitika.hu",
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Kondorfa utca 6.",
        addressLocality: "Budapest",
        postalCode: "1116",
        addressRegion: "XI. kerület",
        addressCountry: "HU",
      },
    },
    jobPosting: openPositions.map((position) => ({
      "@type": "JobPosting",
      title: position.positionName || "Laboratóriumi állás",
      description:
        position.positionDescription ||
        "Csatlakozzon a Bálint Analitika laboratórium csapatához",
      datePosted: position.datePosted || new Date().toISOString().split("T")[0],
      employmentType: position.employmentType || "FULL_TIME",
      hiringOrganization: {
        "@type": "Organization",
        name: "Bálint Analitika Laboratórium",
        sameAs: "https://balintanalitika.hu",
      },
      jobLocation: {
        "@type": "Place",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Kondorfa utca 6.",
          addressLocality: "Budapest",
          postalCode: "1116",
          addressRegion: "XI. kerület",
          addressCountry: "HU",
        },
      },
    })),
  };

  return (
    <>
      <Helmet>
        <title>
          Karrier lehetőségek | Bálint Analitika Laboratórium | Budapest XI.
          kerület
        </title>
        <meta
          name="description"
          content="Csatlakozzon a Bálint Analitika laboratórium csapatához! Aktuális állásajánlatok és karrierlehetőségek az orvosdiagnosztika területén Budapest XI. kerületében."
        />
        <meta
          name="keywords"
          content="laboratóriumi állás, karrier egészségügyben, Bálint Analitika állás, laboratóriumi munka, diagnosztikai állás, Budapest XI. kerület állás"
        />
        <link
          rel="canonical"
          href="https://balintanalitika.hu/orvosdiagnosztika/rolunk/karrier"
        />
        <script type="application/ld+json">
          {JSON.stringify(jobPostingsStructuredData)}
        </script>
      </Helmet>

      <main className="about-career navbar-margin">
        <div className="container">
          <header className="about-career-header">
            <h1 className="about-heading">Karrier a Bálint Analitikánál</h1>
            <p className="about-career-description">
              Csatlakozzon hozzánk és legyen része egy hiteles és innovatív
              orvosdiagnosztika csapatnak, amely már 2007 óta elkötelezett az
              egészségügy javítása mellett Budapest XI. kerületében található
              laboratóriumunkban. Formáljuk együtt a jövőt!
            </p>
          </header>

          <section className="about-career-benefits-section">
            <h2 className="about-heading-secondary">
              Mit kínálunk munkatársainknak?
            </h2>
            <ul className="about-career-benefits-list">
              <li className="about-career-benefits-item">
                <strong>Stabil munkakörnyezet</strong> - 15+ éve működő
                laboratórium
              </li>
              <li className="about-career-benefits-item">
                <strong>Szakmai fejlődés</strong> - folyamatos képzési
                lehetőségek
              </li>
              <li className="about-career-benefits-item">
                <strong>Modern munkakörülmények</strong> - korszerű
                laboratóriumi eszközök
              </li>
              <li className="about-career-benefits-item">
                <strong>Versenyképes juttatások</strong> - a szakmai
                tapasztalatnak megfelelően
              </li>
            </ul>
          </section>
          <section
            className="about-career-positions-section"
            aria-labelledby="open-positions"
          >
            <h2 id="open-positions" className="about-heading-secondary">
              Nyitott pozíciók
            </h2>
            {openPositionsLabor.length > 0 ? (
              <AboutCareerList openPositionsList={openPositionsLabor} />
            ) : (
              <p className="about-career-no-positions">
                Jelenleg nincs nyitott pozíciónk, de folyamatosan bővülünk.
                Amennyiben érdeklődik a laboratóriumunkban való munkalehetőségek
                iránt, kérjük küldje el önéletrajzát az{" "}
                <a
                  href="mailto:karrier@balintanalitika.hu"
                  className="about-career-email-link"
                >
                  karrier@balintanalitika.hu
                </a>{" "}
                email címre.
              </p>
            )}
          </section>
          <section className="about-career-contact-section">
            <h2 className="about-heading-secondary">Kapcsolatfelvétel</h2>
            <p className="about-career-contact-text">
              Kérdése van a karrierlehetőségekkel kapcsolatban? Keressen minket
              az alábbi elérhetőségeken:
            </p>
            <address className="about-career-contact-address">
              <p>
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:karrier@balintanalitika.hu"
                  className="about-career-email-link"
                >
                  karrier@balintanalitika.hu
                </a>
              </p>
              <p>
                <strong>Cím:</strong> 1116 Budapest, Kondorfa utca 6. (XI.
                kerület)
              </p>
              <p>
                <strong>Telefon:</strong>{" "}
                <a href="tel:+3612053044" className="about-career-phone-link">
                  +36 1 205 3044
                </a>
              </p>
            </address>
          </section>
        </div>
      </main>
    </>
  );
};

export default AboutCareer;
